export default __webpack_public_path__ + "static/media/Diabetes.ef588fbd.png";